<template>
  <div>
    <p v-if="profile.internetFW === 'ANY'">
      <label>FW:</label>
      <span>any</span>
    </p>
    <p v-else-if="profile.internetFW === 'MAINTENANCE'">
      <label>FW:</label>
      <span>maintenance</span>
    </p>
    <p v-else-if="profile.internetFW === 'USER'">
      <label>FW:</label>
      <span>{{ profile.profileInternetFw?.profileInternetFwName }}</span>
    </p>

    <p
      v-if="
        'idsIps' in profile &&
        (profile.idsIps === 'DEFAULT' ||
          profile.idsIps === 'IDS' ||
          profile.idsIps === 'IPS')
      "
    >
      <label>IDS/IPS</label>
    </p>

    <p v-if="'urlFiltering' in profile && profile.urlFiltering === 'USER'">
      <label>URL:</label>
      <span>{{ profile.profileUrl?.profileUrlName }}</span>
    </p>

    <p
      v-if="
        'webAntiVirus' in profile &&
        (profile.webAntiVirus === 'DEFAULT' ||
          profile.webAntiVirus === 'ALERT' ||
          profile.webAntiVirus === 'BLOCK')
      "
    >
      <label>WebAV</label>
    </p>

    <p
      v-if="
        'mailAntiVirus' in profile &&
        (profile.mailAntiVirus === 'DEFAULT' ||
          profile.mailAntiVirus === 'ALERT' ||
          profile.mailAntiVirus === 'BLOCK')
      "
    >
      <label>MailAV</label>
    </p>

    <p v-if="'isAntiSpyware' in profile && profile.isAntiSpyware">
      <label>AntiSpy</label>
    </p>

    <p v-if="isAllOff">
      <label>-</label>
    </p>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetProfile } from "@/apis/NwPolicyApi";
import type { NullableProperty } from "@/shims-vue";

/** インターネットType1,4のポリシーのプロファイル表示が出来るコンポーネント */
export default defineComponent({
  name: "PolicyProfile",
  props: {
    /** プロファイル（UTM/IFW） */
    profile: {
      type: Object as PropType<
        | GetProfile
        | NullableProperty<
            GetProfile,
            | "idsIps"
            | "urlFiltering"
            | "webAntiVirus"
            | "mailAntiVirus"
            | "isAntiSpyware"
          >
        | Pick<GetProfile, "internetFW" | "profileInternetFw">
      >,
      required: true,
    },
  },
  computed: {
    /** true: プロファイルの設定が全てOFF系, false: いずれかはON */
    isAllOff(): boolean {
      if ("idsIps" in this.profile) {
        // UTM
        return (
          this.profile.internetFW === "OFF" &&
          (this.profile.idsIps ?? "OFF") === "OFF" &&
          (this.profile.urlFiltering ?? "OFF") === "OFF" &&
          (this.profile.webAntiVirus ?? "OFF") === "OFF" &&
          (this.profile.mailAntiVirus ?? "OFF") === "OFF" &&
          !(this.profile.isAntiSpyware ?? false)
        );
      } else {
        // IFW
        return this.profile.internetFW === "OFF";
      }
    },
  },
});
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
label {
  margin: 0 8px 0 0;
}
</style>
